"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Lasso = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8.543 0c4.36 0 8 2.6 8 6s-3.64 6-8 6a10.53 10.53 0 01-2.63-.329 4 4 0 01-2.794 3.99l-.197.057-1.67.433a1 1 0 01-.614-1.9l.111-.035 1.67-.434a2 2 0 001.498-1.883A1.998 1.998 0 012.543 10v-.014C1.303 8.94.543 7.553.543 6c0-3.4 3.64-6 8-6zm0 2c-3.372 0-6 1.877-6 4 0 .813.386 1.59 1.051 2.24A2 2 0 016.53 9.764 8.52 8.52 0 008.544 10c3.372 0 6-1.877 6-4s-2.628-4-6-4z",
  className: "fill",
  fillRule: "nonzero"
}));
var _default = exports.default = Lasso;